import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../student/Newstudent.css';

function ViewDocent() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [userStatus, setUserStatus] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [values, setValues] = useState({
    firstname: '',
    lastname: '',
    birthdate: '',
    gender: '',
    datein: '',
    dateout: '',
    street: '',
    housenr: '',
    postalcode: '',
    city: '',
    iban: '',
    accountowner: '',
    comments: '',
    cv: '',
    isuser: false,
    email: '',
    mobile: '',
    customer_docent_number: '',
  });

  const navigate = useNavigate();
  const token = sessionStorage.getItem('jwtToken');

  const fetchUserLoginData = useCallback(
    async (email) => {
      if (!email) {
        setUserStatus('Geen waarde');
        setUserRole('Geen waarde');
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/auth/logindata/${email}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 204) {
          setUserStatus('Geen waarde');
          setUserRole('Geen waarde');
        } else if (response.status === 200) {
          setUserStatus(response.data.status || 'Geen waarde');
          setUserRole(response.data.role || 'Geen waarde');
        } else {
          console.error('Unexpected response status:', response.status);
          setUserStatus('Error fetching data');
          setUserRole('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching user login data:', error);
        setUserStatus('Fout');
        setUserRole('Fout');
      }
    },
    [token]
  );

  const fetchDocent = useCallback(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/docent/getdocent/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const docentData = response.data.Data || {};
        setValues(docentData);
        setIsLoading(false);
        fetchUserLoginData(docentData.email);
      })
      .catch((error) => {
        console.error('Error fetching docent data', error);
        setIsLoading(false);
      });
  }, [id, token, fetchUserLoginData]);

  useEffect(() => {
    fetchDocent();
  }, [fetchDocent]);

  const handleCancel = () => {
    navigate('/alldocenten');
  };

  return (
    <div>
      <div className="bg-white p-4">
        <div>
          <h2 className="text-center">Bekijk Docent</h2>
        </div>
        <hr className="seperator" />
        <p className="text-center">Gegevens Docent</p>

        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <form className="form-docent">
            <div className="mb-3 col">
              <p>Status: {userStatus || 'Loading...'}</p>
              <p>Role: {userRole || 'Loading...'}</p>
            </div>

            <div className="mb-3 col">
              <p>Docentnummer: {values.customer_docent_number || ''}</p>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="firstname">Voornaam</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="firstname"
                  placeholder="Voornaam"
                  value={values.firstname || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="lastname">Achternaam</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="lastname"
                  placeholder="Achternaam"
                  value={values.lastname || ''}
                  readOnly
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="birthdate">Geboortedatum</label>
                <input
                  className="form-control rounded-0"
                  type="date"
                  name="birthdate"
                  placeholder="Geboortedatum"
                  value={values.birthdate || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="gender">Geslacht</label>
                <select
                  className="form-control rounded-0"
                  name="gender"
                  value={values.gender || ''}
                  disabled
                >
                  <option value="">Maak een keuze</option>
                  <option value="Male">Man</option>
                  <option value="Female">Vrouw</option>
                  <option value="Other">Anders</option>
                </select>
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="datein">Datum Inschrijving</label>
                <input
                  className="form-control rounded-0"
                  type="date"
                  name="datein"
                  placeholder="Datum Inschrijving"
                  value={values.datein || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="dateout">Datum Uitschrijving</label>
                <input
                  className="form-control rounded-0"
                  type="date"
                  name="dateout"
                  placeholder="Datum Uitschrijving"
                  value={values.dateout || ''}
                  readOnly
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="postalcode">Postcode</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="postalcode"
                  placeholder="Postcode"
                  value={values.postalcode || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="housenr">Huisnummer</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="housenr"
                  placeholder="Huisnummer"
                  value={values.housenr || ''}
                  readOnly
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="street">Straat</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="street"
                  placeholder="Straat"
                  value={values.street || ''}
                  readOnly
                  style={{ backgroundColor: '#FAFAFA' }}
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="city">Plaats</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="city"
                  placeholder="Plaats"
                  value={values.city || ''}
                  readOnly
                  style={{ backgroundColor: '#FAFAFA' }}
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="iban">IBAN</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="iban"
                  placeholder="IBAN"
                  value={values.iban || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="accountowner">Rekeninghouder</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="accountowner"
                  placeholder="Rekeninghouder"
                  value={values.accountowner || ''}
                  readOnly
                />
              </div>
            </div>

            <div className="mb-3">
              <label htmlFor="comments">Opmerkingen</label>
              <textarea
                className="form-control rounded-0"
                rows="5"
                cols="50"
                name="comments"
                placeholder="Opmerkingen"
                value={values.comments || ''}
                readOnly
              />
            </div>

            <div className="mb-3">
              <label htmlFor="cv">CV</label>
              <input
                className="form-control rounded-0"
                type="text"
                name="cv"
                placeholder="Link naar CV of CV data"
                value={values.cv || ''}
                readOnly
              />
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label htmlFor="email">Email</label>
                <input
                  className="form-control rounded-0"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={values.email || ''}
                  readOnly
                />
              </div>
              <div className="mb-3 col">
                <label htmlFor="mobile">Mobiel</label>
                <input
                  className="form-control rounded-0"
                  type="text"
                  name="mobile"
                  placeholder="Mobiel"
                  value={values.mobile || ''}
                  readOnly
                />
              </div>
            </div>

            <hr className="seperator" />

            <div className="row">
              <div className="col-md-6">
                <button
                  type="button"
                  className="btn btn-secondary w-100 rounded-0"
                  onClick={handleCancel}
                >
                  Terug
                </button>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ViewDocent;